module.exports = __webpack_public_path__ + "static/media/Logo FAMZ Guide - Color.ab53fb6b.png";